import { memo, useContext, useEffect, useMemo, useState } from "react";
import { Button, ButtonGroup, Col, Form, Modal, Row, Spinner} from "react-bootstrap";
import { DB_TITLE, FileName, FileName2, FREEZE_FIELD, initialUserUrls, TITLE, userInitialData, colorCode } from "../databases/spName";
import { UpdateUser } from "../databases/users";
import { ICON_DOWNLOAD, ICON_EDIT, ICON_UPLOAD } from "../components/icons";
import { AdminContext } from "../contexts/AdminContext";
import { getFileURL, GetOwnURLS, onDownloadFileClick } from "../databases/files";
import RenderUpdateProfile from "./RenderUpdateProfile";


const RenderUser = memo(({ keyname, user, showType }) => {
    const [showModal, setShowModal] = useState(false);
    const [picModal, setPicModal] = useState(false);

    const [currentURL, setCurrentURL] = useState({url : '', type : '', field : '', updated : '', onLoading : false});

    const [userdata, setUserdata] = useState({...userInitialData})
    const [urls, setUrls] = useState({...initialUserUrls})

    const { updateSingleUser, colorFilters } = useContext(AdminContext)

    useEffect(() => {
        return () => {
            setShowModal(false)
            setPicModal(false)
            setCurrentURL({url : '', type : '', field : '', updated : '', onLoading : false})
            setUserdata({...userInitialData})
            setUrls({...initialUserUrls})
        }
    }, [])

    useEffect(() => {
        const q = async () => {
            const u = await GetOwnURLS(keyname)
            setUrls(i => ({...i, ...u} ))
        }
        q();
    }, [keyname])

    const onShowModal = () => {
        setShowModal(true);
        setUserdata({...user})
    }
    const onSaveClick = async () => {
        await UpdateUser({...userdata}, keyname)
            .then(() => {
                alert('อัปเดตสำเร็จ')
                //setUsers({...users, [keyname] : {...userdata}})
                updateSingleUser(keyname, {...userdata})
                setShowModal(false)
            })
            .catch(() => alert('เกิดข้อผิดพลาด'))
    }

    
        
    const background = useMemo(() => {
        if (user.isInfected) {
            return colorCode.isInfected
        }
        else if (user.isChecked) {
            return colorCode.isChecked
        }
        else if (user.isHighlight){
            return colorCode.isHighlight
        }
        else {
            return 'white'
        }
    }, [user.isInfected, user.isChecked, user.isHighlight])

    const onShowImageClick = async (field) => {
        setCurrentURL(c => ({...c, onLoading : true }))
        const { url, type, size, updated } = await getFileURL(`${keyname}/${FileName[field]}`).catch(() => setCurrentURL(c => ({...c, onLoading : false })))
        setCurrentURL({ url, type, field, size, updated, onLoading : false})
        setPicModal(true)
    }

    const colorFilterHidden = useMemo(() => {
        let b = false
        let nocolor = true
        for (const code in colorCode) {
            if (user[code] && !colorFilters[code]) {
                b = true
            }
            if (user[code]) nocolor = false
        }
        if (nocolor && !colorFilters.white) b = true
        return b
        
    }, [colorFilters, user])


    return (
        <tr style={{background : background, fontSize : '14px', display : colorFilterHidden ? 'none' : ''}}>
        <Modal show={showModal} size='lg' onHide={() => setShowModal(false)}>
            <Modal.Header closeButton style={{background : userdata.isInfected ? colorCode.isInfected : userdata.isChecked ? colorCode.isChecked : userdata.isHighlight ? colorCode.isHighlight : 'white'}}>
                <Modal.Title>แก้ไขข้อมูล : {user.nameEN}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="text-end">
                    <Button variant="danger" onClick={() => setShowModal(false)}>ยกเลิก</Button>
                    <Button variant="success" onClick={onSaveClick}>บันทึก</Button>
                </div>
                <br />
                <div className="text-end" hidden={keyname.length < 24}>
                    <ButtonGroup>
                    <Button 
                        style={{background : colorCode.isChecked, border : 'none', color : 'black'}} 
                        onClick={() => setUserdata(m => ({...m, isInfected : false, isHighlight : false, isChecked : !m.isChecked}))}
                    >ทำสีเขียว</Button>
                    <Button 
                        style={{background : colorCode.isHighlight, border : 'none', color : 'black'}} 
                        onClick={() => setUserdata(m => ({...m, isChecked : false, isInfected : false, isHighlight : !m.isHighlight, }))}
                    >ทำสีเหลือง</Button>
                    <Button 
                        style={{background : colorCode.isInfected, border : 'none', color : 'black'}} 
                        onClick={() => setUserdata(m => ({...m, isChecked : false, isHighlight : false, isInfected : !m.isInfected, }))}
                    >ทำสีแดง</Button>
                    </ButtonGroup>
                    
                </div>
                <Row bsPrefix="row align-items-center">
                    <Col bsPrefix='col-auto'>หมายเหตุ : </Col>
                    <Col><Form.Control value={userdata.note} onChange={e => setUserdata(d => ({...d, note : e.target.value}))}  /></Col>
                </Row>
                <RenderUpdateProfile onEdit={showModal} data={userdata} setData={setUserdata} urls={urls} setUrls={setUrls} isAdminEdit={true} uid={keyname}/>
                <br />
                <br />
            </Modal.Body>
            <Modal.Footer>
                
            </Modal.Footer>
        </Modal>
        <Modal show={picModal} size='xl' onHide={() => setPicModal(false)}>
        <Modal.Header closeButton style={{background : userdata.isInfected ? colorCode.isInfected : userdata.isChecked ? colorCode.isChecked : userdata.isHighlight ? colorCode.isHighlight : 'white'}}>
                <Modal.Title>{FileName2[currentURL.field]}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row bsPrefix='row text-center'>
                    <Col xs='12' lg='6'>
                        {currentURL.url && currentURL.type !== 'application/pdf' ? <img alt='' src={currentURL.url} width='300px' /> : <></>}
                        {currentURL.url && currentURL.type === 'application/pdf' ? 
                            <object data={currentURL.url} type="application/pdf" width='90%' height='90%' style={{minHeight : '500px'}} >
                                ขออภัย บราวเซอร์นี้ไม่สามารถแสดงผล pdf ได้
                            </object> : <></>}
                    </Col>
                    <Col>
                        <br />
                        <div className="bold">{`${user.flightIndex ? user.flightIndex + ' ' : ''}${user.nameEN}`}</div>
                        <br />
                        <div>ขนาดไฟล์ : {currentURL.size}</div>
                        <div>ชนิดไฟล์ : {currentURL.type}</div>
                        <div>เวลา : {currentURL.updated}</div>
                        <div>หมายเหตุ : {user.note}</div>
                        <br />
                        <Button variant='primary' style={{width : '200px'}}
                            onClick={() => onDownloadFileClick(`${keyname}/${FileName[currentURL.field]}`, `${user.flightIndex ? user.flightIndex + ' ' : ''}${user.nameEN}`)}
                        >{ICON_DOWNLOAD} ดาวน์โหลดไฟล์</Button>
                        <br /><br />
                        <a href={currentURL.url} style={{width : '200px'}} target='_blank' rel='noreferrer' className="btn btn-primary">{ICON_UPLOAD} เปิดไฟล์ในแท็บใหม่</a>
                    </Col>
                </Row>
            </Modal.Body>
        </Modal>
        <td style={{paddingBlock : '2px'}}><Button onClick={onShowModal} style={{paddingBlock : '0px', fontSize : '10px'}}>{ICON_EDIT}</Button></td>
        
        {[...DB_TITLE].map((field, index) => (
            <td 
                key={index} style={{ paddingBlock : '2px'}}
                hidden={showType !== TITLE[field].datatype && !FREEZE_FIELD.includes(field)}
            >
                {TITLE[field].options ? (TITLE[field].options[user[field]] || user[field]) : user[field]}
            </td>
        ))}
        <td style={{paddingBlock : '2px'}} hidden={showType !== 'system'}>{TITLE.role.options[user.role]}</td>
        <td style={{paddingBlock : '2px'}} hidden={showType !== 'system'}>{TITLE.register.options[user.register]}</td>
        <td style={{paddingBlock : '2px'}} hidden={showType !== 'system'}>{user.note}</td>
        {[...Object.keys(initialUserUrls)].map((field, index) => (
            <td key={index} style={{paddingBlock : '2px'}} hidden={showType !== TITLE[field].datatype}>
                {user[field] ? <div className="link-style" onClick={() => onShowImageClick(field)}
                    //onClick={() => onDownloadFileClick(`${keyname}/${FileName[field]}`, `${user.flightIndex ? user.flightIndex + ' ' : ''}${user.nameEN}`)}
                >{currentURL.onLoading ? <Spinner size='sm' animation="border" /> : 'คลิก'}</div> : <></>}
            </td>
        ))}
        </tr>
    )
}, (prev, next) => {
    const returnProps = ( 
        prev.keyname === next.keyname
        && prev.user === next.user 
        && prev.showType === next.showType
    )
    return returnProps;
})

export default RenderUser;